// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__gpWTb","title":"ClientReferral_title__3q63_","itemText":"ClientReferral_itemText__2aGeA"};